<template>
  <!--  第一个详情页面-->
  <div class="home_layout">
    <div class="tab-list">
      <div class="tab-btn" :class="{ 'tab-active': tabActive === 0 }" @click="handleFilterData(0)">全部</div>
      <div class="tab-btn" :class="{ 'tab-active': tabActive === 1 }" @click="handleFilterData(1)">已过期</div>
    </div>
    <div class="home_body">
      <div class="data-list" v-if="filterDataList.length > 0">
        <div v-for="item in filterDataList" :key="item.id" class="coupon-item">
          <time class="coupon-time">{{ item.createTime }}</time>
          <div class="coupon-content" @click="detailClick(item)">
            <div class="left">
              <img class="pic" :src="item.picUrl"/>
              <div class="coupon-info">
                <div>
                  <div class="coupon-title">{{ item.title }}</div>
                  <div class="coupon-count">X{{ item.count }}张</div>
                </div>
                <div class="coupon-validate">{{ item.validDate }}</div>
              </div>
            </div>
            <div class="right">
              <div class="coupon-amount">
                <div class="amount">
                  <span>{{ item.amounts }}</span>
                  元
                </div>
              </div>
              <div class="btn" :class="{ 'expired-btn': item.useStatus === 1 }" @click.stop="detailClick(item)">{{
                  setBtnStatus(item)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="home_body_middle_nodata">
        <img
            src="../../../static/images/vip_discounts/nodata.png"
            alt=""
            width="100%"
            class="home_body_middle_nodata_img"/>
        <p class="home_body_middle_nodata_title">暂无优惠券</p>
        <p class="home_body_middle_nodata_content">您还没有领取优惠券喔～</p>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {handleRequestError} from '@/static/js/common'

export default {
  data() {
    return {
      detailinfo: {},
      dataList: [],
      tabActive: 0
    }
  },
  mounted() {
    console.log('88', this.$route.params.goodsType)

    this.getRecords()
  },
  computed: {
    ...mapState(['loginInfo']),
    contents() {
      return this.detailinfo.useMethod
    },
    filterDataList() {
      return this.tabActive === 0
          ? this.dataList
          : this.dataList.filter((item) => {
            return item.expiredStatus === '1'
            // eslint-disable-next-line no-mixed-spaces-and-tabs
          })
    }
  },
  filters: {},
  methods: {
    /** 获取列表 */
    getRecords() {
      let displayMode = localStorage.getItem('displayMode')

      // 根据 displayMode 选择对应的接口
      let apiEndpoint = this.apis.findOrderList
      if (displayMode === '1') {
        apiEndpoint = this.apis.findOrderListSingle // 例如: mode2 请求 findGoodsList 接口
      }

      this.post(apiEndpoint, {
        memberId: this.loginInfo.id
      })
          .then((res) => {
            if (res.data.code === '0') {
              let data = res.data.data
              console.log('data', data)

              data = data.map((item) => {
                // 处理领取时间
                const dateStr = `${item.createTime.substring(0, 4)}年${item.createTime.substring(
                    5,
                    7
                )}月${item.createTime.substring(8, 10)}日`
                const time = item.createTime ? dateStr : '--'
                return {
                  ...item,
                  id: item.goodsId,
                  amounts: item.goodsPrice,
                  count: item.num,
                  title: item.goodsName,
                  content: '每月特权 会员专享',
                  orderId: item.orderId,
                  validDate: item.validDate ? '有效期至' + item.validDate : '长期有效',
                  createTime: time
                }
              })
              this.dataList = data
            }
          })
          .catch((error) => {
            console.log(error)
            handleRequestError(this, error)
          })
    },
    /** 查看 */
    detailClick(item) {
      console.log('99', item)
      console.log(this.loginInfo.id)

      let displayMode = localStorage.getItem('displayMode')
      console.log('打开模式' + displayMode)
      if (displayMode === '1') {
        if (item.expiredStatus === '1') {
          return
        } else if (item.expiredStatus === '0' && item.title == '中萃到家电子券') {
          return;
        } else if (item.expiredStatus === '0' && item.title != '中萃到家电子券') {
          this.$router.push({
            name: 'couponDetail',
            params: {
              goodsName: item.goodsName,
              regionNo: item.regionNo,
              orderId: item.orderId,
              orderDetailId: item.orderDetailId,
              couponId: '',
              memberId: item.memberId,
              seeFlag: item.useStatus != '0' ? '2' : '1',
              goodsId: item.goodsId,
              cardgoodsId: item.id
            }
          })
        }
      }

      //领取两张的页面
      if (displayMode === '2') {
        if (item.expiredStatus === '1') {
          return
        } else if (item.expiredStatus === '0' && item.title == '中萃到家电子券') {
          return
        } else if (item.expiredStatus === '0' && item.title != '中萃到家电子券') {
          this.$router.push({
            name: 'receiveDiscount',
            params: {
              orderId: item.orderId,
              memberId: this.loginInfo.id,
              couponId: item.id,
              goodsId: item.id,
              regionNo: this.$route.params.regionNo
            }
          })
          console.log('111', item.orderId)

          if (item.orderId != null && item.orderId !== '') {
            localStorage.setItem('orderId', item.orderId)
          }
        }
      }
    },
    setBtnStatus(item) {
      console.log('444', item)
      let regionNo = localStorage.getItem('regionNo')
      console.log('当前区域编号' + regionNo)
      console.log('555', item.expiredStatus)
      let displayMode = localStorage.getItem('displayMode')
      console.log('当前模式' + displayMode)
      //放入缓存orderId
      if (item.orderId != null && item.orderId !== '') {
        localStorage.setItem('orderId', item.orderId)
      }

      if (displayMode === '1') {
        //请求接口
        //根据订单id查询出
        console.log(item.orderId)


        if (item.title == '中萃到家电子券') {
          switch (item.expiredStatus) {
            case '0':
              return '已激活'
            case '1':
              return '已过期'
            default:
              return '--'
          }
        }


        if (item.expiredStatus === '1') {
          return '已过期'
        }
        //未过期继续判断 是去使用还是 去查看
        if (item.expiredStatus === '0') {
          //在判断是去领取还是去查看
          if (item.useStatus === '0') {
            return '立即使用'
          } else {
            return '查看'
          }
        }
      } else if (displayMode === '2') {
        if (item.title == '中萃到家电子券') {
          switch (item.expiredStatus) {
            case '0':
              return '已激活'
            case '1':
              return '已过期'
            default:
              return '--'
          }
        } else {
          switch (item.expiredStatus) {
            case '0':
              return ' 查看'
            case '1':
              return '已过期'
            default:
              return '--'
          }
        }
      }
    },
    handleFilterData(index) {
      this.tabActive = index
      // if (index === 1) {
      // 	this.dataList = this.dataList.filter((item) => item.expiredStatus === '1')
      // }
    }
  }
}
</script>
<style scoped lang="less">
.home_layout {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}

.tab-list {
  background: #fff;
  padding: 26px 32px;
  display: flex;
  align-items: center;

  .tab-btn {
    height: 48px;
    line-height: 48px;
    background: #eeeeee;
    border-radius: 8px;
    padding: 0 28px;
    margin-right: 16px;
    color: rgba(0, 0, 0, 0.6);
  }

  .tab-active {
    color: #000;
  }
}

.home_body {
  height: 100%;
  padding: 0 24px;

  .coupon-item {
    .coupon-time {
      font-size: 28px;
      color: #919191;
      margin-top: 24px;
      margin-bottom: 16px;
      text-align: center;
      display: block;
    }

    .coupon-content {
      background: #fff;
      border-radius: 16px;
      display: flex;

      .left {
        display: flex;
        flex: 1;
        padding-right: 28px;
        border-right: 1px dashed #d3d3d3;
        padding: 20px 20px 20px 28px;

        .coupon-info {
          margin-left: 24px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .coupon-title {
            font-size: 26px;
            color: #3f2a20;
            line-height: 38px;
            font-weight: bold;
          }

          .coupon-count {
            font-size: 22px;
            color: #dd5701;
            line-height: 33px;
            margin-top: 10px;
          }

          .coupon-validate {
            font-size: 20px;
            color: #919191;
            line-height: 28px;
          }
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 20px 28px 20px 28px;

        .coupon-amount {
          color: #dd5701;
          font-size: 30px;
          display: flex;
          align-items: center;
          flex: 1;

          .amount {
            display: flex;
            align-items: end;
          }

          span {
            font-size: 60px;
            margin-right: 6px;
            font-weight: bold;
            line-height: 1;
          }
        }

        .btn {
          width: 170px;
          height: 56px;
          line-height: 56px;
          border-radius: 32px;
          background: #fb7019;
          color: #fff;
          font-size: 28px;
          text-align: center;
        }

        .expired-btn {
          background: rgba(251, 112, 25, 0.1);
          color: #dd5701;
        }
      }

      .pic {
        width: 176px;
        height: 176px;
        border-radius: 16px;
        display: block;
      }
    }
  }

  &_middle {
    &_nodata {
      display: grid;
      justify-content: center;
      align-items: center;
      padding-top: 30%;

      &_img {
        max-width: 200px;
        margin: 0 auto;
      }

      &_title {
        color: #3f3f3f;
        font-size: 30px;
        text-align: center;
        margin-top: 24px;
        font-weight: 400;
      }

      &_content {
        color: #848484;
        font-size: 20px;
        text-align: center;
        margin-top: 16px;
      }
    }
  }
}
</style>
